const VALID_USERS = [
    'duverj@gmail.com',
    'duver@tresdobleu.com',
    'digitalnatam@gmail.com',
    'contacto@etiquettediseno.com',
];

export const designsCollection = 'designs';

export const collectIdsAndDocs = (doc) => {
    return {
        id: doc.id,
        ...doc.data(),
    };
};

export const getValueWithoutUnit = (value, unit) => {
    if (!value || !unit) return;
    const output = value.split(unit);
    return output[0];
};

export const checkUser = (user) => {
    const isLogged = sessionStorage.getItem('et-logged');
    if (isLogged) return isLogged;
    if (!user) return;
    if (VALID_USERS.includes(user.email)) {
        console.log('setting session');
        sessionStorage.setItem('et-logged', true);
        return true;
    }
};

export const sideScroll = (element, direction, speed, distance, step) => {
    let scrollAmount = 0;
    const slideTimer = setInterval(function () {
        if (direction === 'left') {
            element.scrollLeft -= step;
        } else {
            element.scrollLeft += step;
        }
        scrollAmount += step;
        if (scrollAmount >= distance) {
            window.clearInterval(slideTimer);
        }
    }, speed);
};

export const COLORS = [
    { name: 'Blanco', hex: 'FFFFFF' },
    { name: 'Negro', hex: '000000' },
    { name: 'Vino tinto', hex: '582A25' },
    { name: 'Crudo', hex: 'FAFBEE' },
    { name: 'Amarillo', hex: 'F1EEA4' },
    { name: 'Gris', hex: '55565A' },
    { name: 'Gris claro', hex: '768797' },
    { name: 'Rosa medio', hex: 'CDA2C7' },
    { name: 'Azul oscuro', hex: '2A385D' },
    { name: 'Palo de rosa', hex: 'E773A8' },
    { name: 'Crema', hex: 'EFCEC8' },
    { name: 'Rojo', hex: 'E65F53' },
    { name: 'Azul', hex: '2771b6' },
    { name: 'Azul petróleo', hex: '29337b' },
    { name: 'Morado', hex: '652880' },
    { name: 'Fucsia', hex: 'e43e7f' },
    { name: 'Verde oscuro', hex: '2c6834' },
    { name: 'Naranja', hex: 'e84c32' },
    { name: 'Rojo fuerte', hex: 'e1332f' },
];

export const FUENTES = [
    { name: 'Acumin Pro', value: 'Acumin' },
    { name: 'Androgyne', value: 'Androgyne' },
    { name: 'Calm Down Beibeh', value: 'Calm' },
    { name: 'Chocolate Dipped Strawberry', value: 'Chocolate' },
    { name: 'Elegant Typewriter', value: 'Elegant' },
    { name: 'Metafiz', value: 'Metafiz' },
    { name: 'Odin', value: 'Odin' },
    { name: 'Chalkboard', value: 'Chalkboard' },
    { name: 'Bebas Neue', value: 'Bebas' },
    { name: 'Thank you so much', value: 'ThankYou' },
    { name: 'Sprinkles', value: 'Sprinkles' },
];
